import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import About from "@/sections/About";
import Services from "@/sections/Services";
import Projects from "@/sections/Projects";
import Capabilities from "@/sections/Capabilities";
import HSE from "@/sections/HSE";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

function Home() {
  return (
    <div className="App font-body" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <About />
        <Services />
        <Projects />
        <Capabilities />
        <HSE />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
